import { Divider, Row } from "antd";
import { BackToButton } from "components/Shared/BackToButton";
import { PageTitle } from "components/Shared/PageTitle";
import { useFetchEntity } from "hooks/useEntitiesApi";
import { useFetchSeasonsByEntityId } from "hooks/useSeasonsApi";
import { useFetchVenues } from "hooks/useVenuesApi";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { SeasonTable } from "../../../components/Shared/SeasonTable";
import { EntityDetails } from "./components/EntityDetails";
import { useSeasonsColumns } from "./hooks/useSeasonsColumns";

export const DashboardPage = () => {
  const { customerId, sport, organizationId, entityId: entityIdFromParams } = useParams();
  const entityId = entityIdFromParams || "undefined";

  const { formatMessage } = useIntl();

  const { data: entityResponse, isLoading: isEntityLoading } = useFetchEntity({
    entityId,
  });
  const { data: venuesResponse, isLoading: isVenuesLoading } = useFetchVenues();
  const { data: seasonsResponse, isLoading: isSeasonsLoading } = useFetchSeasonsByEntityId({ entityId });

  const entity = entityResponse?.data?.[0];
  if (entity) {
    entity.defaultVenue = venuesResponse?.data?.find((x: any) => x.venueId === entity.defaultVenueId);
  }
  const seasons = seasonsResponse?.data || [];

  const columns = useSeasonsColumns();

  return (
    <>
      <Row className="mt-15" justify="space-between">
        <PageTitle
          isLoading={isEntityLoading}
          title={formatMessage({ id: "dashboardPage.title" }, { entityName: entity?.nameFullLocal })}
        />
        <BackToButton
          to={`/${customerId}/${sport}/${organizationId}/entities`}
          btnText={formatMessage({ id: "back.to.entities" })}
        />
      </Row>
      <Divider />
      <EntityDetails isLoading={isEntityLoading || isVenuesLoading} entity={entity} />
      <SeasonTable
        title={formatMessage({ id: "dashboardPage.seasons.title" })}
        isLoading={isSeasonsLoading}
        seasons={seasons}
        columns={columns}
      />
    </>
  );
};
